module.exports = __webpack_public_path__ + "static/media/info_graphic_1.41e2bc0f.svg";